import axios from 'axios';

import { FetchStatus } from '@powdr/constants';
import { getNodeApiDomain } from '@powdr/utils';

import { TRAFFIC_PENDING, TRAFFIC_SUCCESS, TRAFFIC_ERROR } from '../types';

export const getTraffic = () => async (dispatch, getState) => {
  const trafficStatus = getState().traffic.status;

  if (trafficStatus !== FetchStatus.LOADING && trafficStatus !== FetchStatus.PENDING) {
    try {
      dispatch({
        type: TRAFFIC_PENDING,
        payload: null,
      });

      const res = await axios.get(`${getNodeApiDomain()}/dor/traffic`);

      dispatch({
        type: TRAFFIC_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: TRAFFIC_ERROR,
        payload: error,
      });
    }
  }
};
